<template>
    <footer class="support-and-help-sec">
        <div class="support-and-socail-icons" v-if="$siteSettings?.data?.business_type == 2">
            <div class="support">
                <h3>{{ $t('twenty-four-supp','24X7 Support')}}</h3>
            </div>
            <div class="socail-icons" v-if="$siteSettings?.data?.social_link && $siteSettings?.data?.business_type == 2">
                <ul>
                    <li v-if="$siteSettings?.data?.social_link?.facebook_link">
                        <a :href="$siteSettings.data?.social_link.facebook_link" target="_blank"><img loading="lazy"
                                src="@/assets/images/facebook-social.svg" alt="" /></a>
                    </li>
                    <li v-if="$siteSettings?.data?.social_link?.instagram_link">
                        <a :href="$siteSettings.data?.social_link.instagram_link" target="_blank"><img loading="lazy"
                                src="@/assets/images/instagram-icon.svg" alt="" /></a>
                    </li>
                    <li v-if="$siteSettings?.data?.social_link?.telegram_link">
                        <a :href="$siteSettings.data?.social_link.telegram_link" target="_blank"><img loading="lazy"
                                src="@/assets/images/telegram-social.svg" alt="" /></a>
                    </li>
                    <li v-if="$siteSettings?.data?.social_link?.twitter_link">
                        <a :href="$siteSettings.data?.social_link.twitter_link" target="_blank"><img loading="lazy"
                                src="@/assets/images/twitter-social.svg" alt="" /></a>
                    </li>
                    <li v-if="$siteSettings?.data?.social_link.youtube_link">
                        <a :href="$siteSettings?.data?.social_link.youtube_link" target="_blank"><img loading="lazy"
                                src="@/assets/images/youtube-social.svg" alt="" /></a>
                    </li>
                    <!-- <li>
                        <a href="#" target="_blank">
                            <img src="@/assets/images/message-social.svg" alt="" />
                        </a>
                    </li> -->
                </ul>
            </div>
        </div>
        <div class="footer-menu-list">
            <ul>
                <li>
                    <router-link :to="{ name: 'AboutUs' }">{{ $t('about-us','About Us')}}</router-link>
                </li>
                <li v-if="$siteSettings?.data?.business_type == 2">
                    <router-link :to="{ name: 'faq' }">{{ $t('','FAQ')}}</router-link>
                </li>

                <template v-if="this.$auth.status">
                    <!-- <li>
                        <router-link :to="{ name: 'faq' }">{{ $t('faq','FAQ')}}</router-link>
                    </li> -->
                    <li>
                        <a @click="getRules()" href="#rulesModal" data-bs-toggle="modal">{{ $t('rules','Rules')}}</a>
                    </li>
                </template>
                <br>
                <li>
                    <router-link :to="{ name: 'terms-conditions' }">{{ $t('terms-and-conditions','Terms and Conditions')}}</router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'responsible-gaming' }">{{ $t('responsible-gaming','Responsible Gaming')}}</router-link>
                </li>
            </ul>
        </div>
        <div class="more-secure-safe-sec">
            <div class="secure-protected-sec">
                <div class="secure-logo">
                    <img loading="lazy" src="@/assets/images/ssl.webp" alt="ssl" />
                </div>
                <div class="protected-safe-text">
                    <b>{{ $t('hunder-per-safe','100% SAFE')}}</b>
                    <div>{{ $t('prote-connec-encry-data','Protected connection and encrypted data')}}.</div>
                </div>
            </div>
            <div class="footer-apk-dflex">
                <div class="f-other">
                    <a href="#eighteen-plus-model" data-bs-toggle="modal">
                        <img loading="lazy" src="@/assets/images/18plus.webp" alt="18+" />
                    </a>
                    <a href="https://www.gamcare.org.uk/" target="_blank">
                        <img loading="lazy" src="@/assets/images/gamecare.webp" alt="gamecare" />
                    </a>
                    <a href="https://www.gamblingtherapy.org/" target="_blank">
                        <img loading="lazy" src="@/assets/images/gt.webp" alt="gt" />
                    </a>
                </div>
                <!-- <div class="download-app">
                    <a href="#install-apk-model" data-bs-toggle="modal">
                        <img loading="lazy" src="@/assets/images/android-apk.svg" alt="android-apk" />
                    </a>
                </div> -->
            </div>
        </div>
        <div class="copy-rgt-sec">
            <span>©{{ $t('copy-right-reserved','Copyright 2025. All Rights Reserved')}}.</span>
        </div>
    </footer>
    <div class="go-top-sec">
        <div class="container">
            <div class="fixed-bottom-btns-sec">		
                <a href="javascript:void(0);" v-if="($route.name == 'Home' || $route.name == 'Home1') && $helper.isMobile()" class="casino_chip" @click="loadMiniGames()">
                    <img src="@/assets/images/casino-chip.png" loading="lazy">
                </a>
                <div class="game_lobby_blank" v-if="miniGameUrl"></div>
                <div class="game_lobby_iframe" ref="game_lobby_iframe" v-if="miniGameUrl">
                    <span class="lobby-iframe-close-icon" @click="miniGameUrl = null">
                        <i class="fa fa-chevron-down"></i>
                    </span>
                    <iframe :src="miniGameUrl"></iframe>
                </div>					
                <WhatsappModal   />
            </div>
        </div>
    </div>


    <div class="eighteenPlusFooter-sec">
        <EighteenPlusModal></EighteenPlusModal>
    </div>

    <div class="fixed-wh-logo" :style="{ top: floaterTop + 'px' }" v-if="!$auth.status && ($route.name == 'Home' || $route.name == 'Home1')">
        <a :href="'https://wa.me/' + $siteSettings?.data?.social_link?.whatsappno1" target="_blank" v-if="$siteSettings?.data?.social_link?.whatsappno1">
            <div class="whatsapp-floatter-icon">
                <div class="whatsapp-text">
                    <span>Get an ID Instantly on Whatsapp</span>
                    <span>Click Here Now</span>
                </div>
                <img loading="lazy" src="@/assets/images/whatsapp-share.svg" alt="whatsapp-share">
            </div>
        </a>
        <a :href="$siteSettings?.data?.social_link?.telegram_link" target="_blank" v-if="$siteSettings?.data?.social_link?.telegram_link">
            <img loading="lazy" src="@/assets/images/telegram-share.svg" alt="telegram-share">
        </a>
        <div>
        <button class="btnFixed-bottom" @click="$refs.chat.toggleChatModal()" >
            <img  loading="lazy" src="@/assets/images/chatboat-icon.svg" alt="message-share">
        </button>
    </div>
    </div>
    <RulesModal :siteRuleData="siteRuleData"></RulesModal>
    <ChatComponent ref="chat" />
</template>

<script>
import { defineAsyncComponent } from 'vue';
export default {
    name: 'Support',
    components: {
        EighteenPlusModal: defineAsyncComponent(() => import('@/shared/components/modal/EighteenPlusModal.vue')),
        WhatsappModal: defineAsyncComponent(() => import('./components/WhatsappModal.vue')),
        ChatComponent: defineAsyncComponent(() => import('@/modules/chat/views/ChatComponent.vue')),
        RulesModal: defineAsyncComponent(() => import('../modal/RulesModal.vue')),
    },
    data() {
        return {
            showButton: false,
            miniGameUrl: null,
            floaterTop: 300,
            timeout: null,
            siteRuleData: null,
        }
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        clearTimeout(this.timeout);
    },
    methods: {
        getRules() {
            if(this.siteRuleData) {
                return;
            } 
            let ruleResp = this.$siteSettings?.data?.rules;
            this.siteRuleData = {}
            ruleResp.forEach(item => {
                this.siteRuleData[item.type] = item.content;
            })
        },
        handleScroll() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                const winScrollTop = window.scrollY;
                const winHeight = window.innerHeight;
                const fromBottom = (winHeight * 50) / 100;
                this.floaterTop = winScrollTop + fromBottom;
            }, 50); // Adjust the timeout duration as needed
        },
        async clickOnWhatsapp() {
            this.$refs.whatsappDep.getParentWhatsappNumber();
        },
        loadMiniGames(){
            if (!this.$auth?.status) {
                this.$errorToast(this.$t('login-for-mini-games','Please Login For Mini Games'));
                return;
            }
            const miniGameData = this.$store.getters.gamesData?.['yuvi-games']?.games[0];
            if (!miniGameData) {
                this.$errorToast(this.$t('minigame-no-data','Mini Game Data Not Found.'));
                return;
            }
            let data = {
				type: 'casino',
				game_code: miniGameData.game_code,
				section_id: miniGameData.sm_id
			};
            this.$apiCall('post', 'GET_THIRD_PARTY_API', data).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        if (response.data.error != null) {
                        this.$errorToast(res.data.error.toString());
                    }
                    else{
                        this.miniGameUrl = response.data.url;
                        if (this.miniGameUrl == null || this.miniGameUrl == undefined || this.miniGameUrl == '') {
                            this.$errorToast('URL not found.')
                            this.closeModal();
                        }
                    }
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0] || 'An error occurred.');
                }
            });
        },
    }

}
</script>

<style></style>